import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, Progress } from "reactstrap";

class Loading extends Component {
  render() {
    const { isOpen } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        centered={true}
        fade={false}
        backdropTransition={{ timeout: 0 }}
        modalTransition={{ timeout: 0 }}
      >
        <ModalHeader>Loading...</ModalHeader>
        <ModalBody>
          <Progress animated value="100" />
        </ModalBody>
      </Modal>
    );
  }
}

export default Loading;
